export default {
    data() {
        return {
            component: {},
            isEditing: false,
            obj: {},
            isClone: false,
        }
    },
    methods: {
        clone(obj) {
            this.obj = obj;
            const component = Object.assign({}, obj);
            this.component = component;
        },
        edit() {
            this.isEditing = true;
        },
        save() {
            this.$emit('save', this.component);
            this.isEditing = false;
        },
        cancel() {
            this.clone(this.obj);
            this.isEditing = false;
        },
        isEqual(obj1, obj2) {
            const isObject = (obj) => obj !== null && typeof obj === "object";
  
            const deepEqual = (a, b) => {
              if (isObject(a) && isObject(b)) {
                const keysA = Object.keys(a);
                const keysB = Object.keys(b);
  
                if (keysA.length !== keysB.length) {
                  return false;
                }
  
                for (let key of keysA) {
                  const valA = a[key];
                  const valB = b[key];
  
                  if (!deepEqual(valA, valB)) {
                    return false;
                  }
                }
  
                return true;
              } else if (Array.isArray(a) && Array.isArray(b)) {
                if (a.length !== b.length) {
                  return false;
                }
  
                for (let i = 0; i < a.length; i++) {
                  if (!deepEqual(a[i], b[i])) {
                    return false;
                  }
                }
  
                return true;
              } else {
                return a === b;
              }
            };
  
            return deepEqual(obj1, obj2);
          },
          deepClone(obj) {
            if (obj === null || typeof obj !== 'object') {
              return obj;
            }
  
            if (Array.isArray(obj)) {
              const newArray = [];
              for (const item of obj) {
                newArray.push(this.deepClone(item));
              }
              return newArray;
            }
  
            const newObj = {};
            for (const key in obj) {
              if (Object.prototype.hasOwnProperty.call(obj, key)) {
                newObj[key] = this.deepClone(obj[key]);
              }
            }
  
            return newObj;
          },

    },
    watch: {
        component: {
            deep: true,
            handler(newValue, oldValue) {
                if (Object.keys(oldValue).length) {
                    this.$emit('update', this.component);
                }
            }
        }
    }
}